<ng-container *ngIf="is_loading">
<!--  <mat-progress-bar mode="indeterminate"></mat-progress-bar>-->
  <mat-spinner [diameter]="30"></mat-spinner>
</ng-container>


<mat-form-field  *ngIf="cagad_campaign_object.length>0"> <!--appearance="fill"-->
  <mat-label>Select Campaign</mat-label>
  <mat-select (selectionChange)="selectCampaignEvent($event)">
    <mat-option *ngFor="let dt of cagad_campaign_object" [value]="dt.id">
      {{dt.name}}
    </mat-option>
  </mat-select>
</mat-form-field>

<br>


<mat-form-field  *ngIf="cagad_adgroup_object.length>0 && hide_adgroups==false"> <!--appearance="fill"-->
  <mat-label>Select {{adgroup_adset_name}}</mat-label>
  <mat-select (selectionChange)="selectAdgroupEvent($event)">
    <mat-option *ngFor="let dt of cagad_adgroup_object" [value]="dt.id">
      {{dt.name}}
    </mat-option>
  </mat-select>
</mat-form-field>

<br>


<mat-form-field  *ngIf="cagad_ad_object.length>0 && hide_ads==false"> <!--appearance="fill"-->
  <mat-label>Select Ad</mat-label>
  <mat-select (selectionChange)="selectAdEvent($event)">
    <mat-option *ngFor="let dt of cagad_ad_object" [value]="dt.id">
      {{dt.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
